var weatherUtils = require('./weather-utils.js');

var _require = require('./utils.js'),
    toFixed = _require.toFixed,
    toInt = _require.toInt; // Configuration and specification of data properties


var dataSpec = {
  POST_CHARACTER_LIMIT: 300,
  DATA_SPEC: {
    ID: {
      type: 'Int'
    },
    PASSKEY: {
      type: 'String'
    },
    dateutc: {
      type: 'String',
      label: 'Date'
    },
    winddir: {
      type: 'Int',
      label: 'Wind Direction',
      suff: '°'
    },
    windspeedmph: {
      type: 'Float',
      label: 'Wind Speed',
      suff: ' mph',
      units: ['mph', 'ft/sec', 'm/sec', 'km/hr', 'knots'],
      spokenUnits: ['miles per hour', 'feet per second', 'meters per second', 'kilometers per hour', 'knots']
    },
    windgustmph: {
      type: 'Float',
      label: 'Wind Gust',
      suff: ' mph',
      units: 'windspeedmph'
    },
    maxdailygust: {
      type: 'Float',
      label: 'Max Daily Gust',
      suff: ' mph',
      units: 'windspeedmph'
    },
    windgustdir: {
      type: 'Int',
      label: 'Wind Gust Direction',
      suff: '°'
    },
    windspdmph_avg2m: {
      type: 'Float',
      label: 'Avg Wind Speed (2 mins)',
      suff: ' mph',
      units: 'windspeedmph'
    },
    winddir_avg2m: {
      type: 'Int',
      label: 'Avg Wind Direction (2 mins)',
      suff: '°'
    },
    windspdmph_avg10m: {
      type: 'Float',
      label: 'Avg Wind Speed (10 mins)',
      suff: ' mph',
      units: 'windspeedmph'
    },
    winddir_avg10m: {
      type: 'Int',
      label: 'Avg Wind Direction (10 mins)',
      suff: '°'
    },
    humidity: {
      type: 'Int',
      label: 'Outdoor Humidity',
      suff: '%',
      spokenUnit: 'percent'
    },
    humidity1: {
      type: 'Int',
      label: 'Humidity 1',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity2: {
      type: 'Int',
      label: 'Humidity 2',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity3: {
      type: 'Int',
      label: 'Humidity 3',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity4: {
      type: 'Int',
      label: 'Humidity 4',
      private: true,
      suff: '%',
      spokenUnit: 'percent'
    },
    humidity5: {
      type: 'Int',
      label: 'Humidity 5',
      private: true,
      suff: '%',
      spokenUnit: 'percent'
    },
    humidity6: {
      type: 'Int',
      label: 'Humidity 6',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity7: {
      type: 'Int',
      label: 'Humidity 7',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity8: {
      type: 'Int',
      label: 'Humidity 8',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity9: {
      type: 'Int',
      label: 'Humidity 9',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidity10: {
      type: 'Int',
      label: 'Humidity 10',
      suff: '%',
      private: true,
      spokenUnit: 'percent'
    },
    humidityin: {
      type: 'Int',
      label: 'Indoor Humidity',
      suff: '%',
      spokenUnit: 'percent',
      private: true
    },
    humiditykestrel: {
      type: 'Float',
      label: 'Relative Humidity',
      suff: '%',
      spokenUnit: 'percent',
      private: true
    },
    tempf: {
      type: 'Float',
      label: 'Outdoor Temperature',
      suff: '°F',
      units: ['°F', '°C'],
      spokenUnits: ['degrees', 'degrees']
    },
    tempfkestrel: {
      type: 'Float',
      label: 'Temperature',
      suff: '°F',
      units: 'tempf',
      spokenUnits: ['degrees', 'degrees'],
      private: true
    },
    temp1f: {
      type: 'Float',
      label: 'Temperature 1',
      suff: '°F',
      units: 'tempf',
      private: true
    },
    temp2f: {
      type: 'Float',
      label: 'Temperature 2',
      suff: '°F',
      units: 'tempf',
      private: true
    },
    temp3f: {
      type: 'Float',
      label: 'Temperature 3',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp4f: {
      type: 'Float',
      label: 'Temperature 4',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp5f: {
      type: 'Float',
      label: 'Temperature 5',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp6f: {
      type: 'Float',
      label: 'Temperature 6',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp7f: {
      type: 'Float',
      label: 'Temperature 7',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp8f: {
      type: 'Float',
      label: 'Temperature 8',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp9f: {
      type: 'Float',
      label: 'Temperature 9',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    temp10f: {
      type: 'Float',
      label: 'Temperature 10',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike: {
      type: 'Float',
      label: 'Feels Like',
      suff: '°F',
      units: 'tempf'
    },
    feelsLike1: {
      type: 'Float',
      label: 'Feels Like 1',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike2: {
      type: 'Float',
      label: 'Feels Like 2',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike3: {
      type: 'Float',
      label: 'Feels Like 3',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike4: {
      type: 'Float',
      label: 'Feels Like 4',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike5: {
      type: 'Float',
      label: 'Feels Like 5',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike6: {
      type: 'Float',
      label: 'Feels Like 6',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike7: {
      type: 'Float',
      label: 'Feels Like 7',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike8: {
      type: 'Float',
      label: 'Feels Like 8',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike9: {
      type: 'Float',
      label: 'Feels Like 9',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLike10: {
      type: 'Float',
      label: 'Feels Like 10',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    feelsLikein: {
      type: 'Float',
      label: 'Indoor Feels Like',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint: {
      type: 'Float',
      label: 'Dew Point',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint1: {
      type: 'Float',
      label: 'Dew Point 1',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint2: {
      type: 'Float',
      label: 'Dew Point 2',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint3: {
      type: 'Float',
      label: 'Dew Point 3',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint4: {
      type: 'Float',
      label: 'Dew Point 4',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint5: {
      type: 'Float',
      label: 'Dew Point 5',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint6: {
      type: 'Float',
      label: 'Dew Point 6',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint7: {
      type: 'Float',
      label: 'Dew Point 7',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint8: {
      type: 'Float',
      label: 'Dew Point 8',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint9: {
      type: 'Float',
      label: 'Dew Point 9',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPoint10: {
      type: 'Float',
      label: 'Dew Point 10',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    dewPointin: {
      type: 'Float',
      label: 'Indoor Dew Point',
      suff: '°F',
      private: true,
      units: 'tempf'
    },
    soiltemp1: {
      type: 'Float',
      label: 'Soil Temperature 1',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp2: {
      type: 'Float',
      label: 'Soil Temperature 2',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp3: {
      type: 'Float',
      label: 'Soil Temperature 3',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp4: {
      type: 'Float',
      label: 'Soil Temperature 4',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp5: {
      type: 'Float',
      label: 'Soil Temperature 5',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp6: {
      type: 'Float',
      label: 'Soil Temperature 6',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp7: {
      type: 'Float',
      label: 'Soil Temperature 7',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp8: {
      type: 'Float',
      label: 'Soil Temperature 8',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp9: {
      type: 'Float',
      label: 'Soil Temperature 9',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp10: {
      type: 'Float',
      label: 'Soil Temperature 10',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp11: {
      type: 'Float',
      label: 'Soil Temperature 11',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp12: {
      type: 'Float',
      label: 'Soil Temperature 12',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp13: {
      type: 'Float',
      label: 'Soil Temperature 13',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp14: {
      type: 'Float',
      label: 'Soil Temperature 14',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp15: {
      type: 'Float',
      label: 'Soil Temperature 15',
      suff: '°F',
      units: 'tempf'
    },
    soiltemp16: {
      type: 'Float',
      label: 'Soil Temperature 16',
      suff: '°F',
      units: 'tempf'
    },
    soilhum1: {
      type: 'Int',
      label: 'Soil Moisture 1',
      suff: '%',
      units: ['%', ' '],
      spokenUnits: ['percent', '']
    },
    soilhum2: {
      type: 'Int',
      label: 'Soil Moisture 2',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum3: {
      type: 'Int',
      label: 'Soil Moisture 3',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum4: {
      type: 'Int',
      label: 'Soil Moisture 4',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum5: {
      type: 'Int',
      label: 'Soil Moisture 5',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum6: {
      type: 'Int',
      label: 'Soil Moisture 6',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum7: {
      type: 'Int',
      label: 'Soil Moisture 7',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum8: {
      type: 'Int',
      label: 'Soil Moisture 8',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum9: {
      type: 'Int',
      label: 'Soil Moisture 9',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum10: {
      type: 'Int',
      label: 'Soil Moisture 10',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum11: {
      type: 'Int',
      label: 'Soil Moisture 11',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum12: {
      type: 'Int',
      label: 'Soil Moisture 12',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum13: {
      type: 'Int',
      label: 'Soil Moisture 13',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum14: {
      type: 'Int',
      label: 'Soil Moisture 14',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum15: {
      type: 'Int',
      label: 'Soil Moisture 15',
      suff: '%',
      units: 'soilhum1'
    },
    soilhum16: {
      type: 'Int',
      label: 'Soil Moisture 16',
      suff: '%',
      units: 'soilhum1'
    },
    tempinf: {
      type: 'Float',
      label: 'Indoor Temperature',
      suff: '°F',
      units: 'tempf',
      private: true
    },
    hourlyrainin: {
      type: 'Float',
      label: 'Rain Rate',
      suff: ' in/hr',
      units: ['in/hr', 'mm/hr'],
      spokenUnits: ['inches per hour', 'millimeters per hour']
    },
    dailyrainin: {
      type: 'Float',
      label: 'Daily Rain',
      suff: ' in',
      units: ['in', 'mm'],
      spokenUnits: ['inches', 'millimeters']
    },
    weeklyrainin: {
      type: 'Float',
      label: 'Weekly Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    monthlyrainin: {
      type: 'Float',
      label: 'Monthly Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    yearlyrainin: {
      type: 'Float',
      label: 'Yearly Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    eventrainin: {
      type: 'Float',
      label: 'Event Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    totalrainin: {
      type: 'Float',
      label: 'Total Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    '24hourrainin': {
      type: 'Float',
      label: '24 Hour Rain',
      suff: ' in',
      units: 'dailyrainin'
    },
    baromrelin: {
      type: 'Float',
      label: 'Relative Pressure',
      suff: ' inHg',
      units: ['inHg', 'mmHg', 'hPa'],
      spokenUnits: ['inches', 'millimeters', 'hectopascals']
    },
    baromabsin: {
      type: 'Float',
      label: 'Absolute Pressure',
      suff: ' inHg',
      units: 'baromrelin'
    },
    uv: {
      type: 'Float',
      label: 'Ultra-Violet Radiation Index',
      suff: '',
      avgFormat: toFixed(1)
    },
    solarradiation: {
      type: 'Float',
      label: 'Solar Radiation',
      suff: ' W/m^2',
      units: ['W/m^2', 'lux'],
      spokenUnits: ['', 'lux']
    },
    co2: {
      type: 'Float',
      label: 'CO2',
      suff: ' ppm',
      units: 'parts per million'
    },
    relay1: {
      type: 'Bool',
      private: true,
      label: 'Relay 1'
    },
    relay2: {
      type: 'Bool',
      private: true,
      label: 'Relay 2'
    },
    relay3: {
      type: 'Bool',
      private: true,
      label: 'Relay 3'
    },
    relay4: {
      type: 'Bool',
      private: true,
      label: 'Relay 4'
    },
    relay5: {
      type: 'Bool',
      private: true,
      label: 'Relay 5'
    },
    relay6: {
      type: 'Bool',
      private: true,
      label: 'Relay 6'
    },
    relay7: {
      type: 'Bool',
      private: true,
      label: 'Relay 7'
    },
    relay8: {
      type: 'Bool',
      private: true,
      label: 'Relay 8'
    },
    relay9: {
      type: 'Bool',
      private: true,
      label: 'Relay 9'
    },
    relay10: {
      type: 'Bool',
      private: true,
      label: 'Relay 10'
    },
    pm25: {
      type: 'Float',
      suff: 'µg/m^3',
      label: 'PM2.5 Air Quality Sensor',
      avgFormat: toInt
    },
    pm25_24h: {
      type: 'Float',
      suff: 'µg/m^3',
      label: 'PM2.5 Air Quality Sensor, 24 hour running average',
      avgFormat: toFixed(1)
    },
    pm25_in: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      label: 'PM2.5 Air Quality Sensor, indoor',
      avgFormat: toFixed(1)
    },
    pm25_in_24h: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      label: 'PM2.5 Air Quality Sensor indoor, 24 hour running average',
      avgFormat: toFixed(1)
    },
    pm25_in_aqin: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      avgFormat: toInt,
      label: 'PM2.5 Air Quality Sensor indoor, AQIN sensor'
    },
    pm25_in_24h_aqin: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      avgFormat: toInt,
      label: 'PM2.5 Air Quality Sensor indoor, 24 hour running average, AQIN sensor'
    },
    pm10_in_aqin: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      avgFormat: toInt,
      label: 'PM10 Air Quality Sensor'
    },
    pm10_in_24h_aqin: {
      type: 'Float',
      suff: 'µg/m^3',
      private: true,
      avgFormat: toInt,
      label: 'PM10 Air Quality Sensor, 24 hour running average'
    },
    co2_in_aqin: {
      type: 'Int',
      label: 'Indoor CO2 from AQIN',
      suff: 'ppm',
      avgFormat: toInt,
      private: true
    },
    co2_in_24h_aqin: {
      type: 'Float',
      label: 'Indoor CO2 from AQIN, 24 hour running average',
      suff: 'ppm',
      avgFormat: toInt,
      private: true
    },
    pm_in_temp_aqin: {
      type: 'Float',
      suff: '°F',
      units: 'tempf',
      label: 'Indoor PM sensor temperature',
      private: true
    },
    pm_in_humidity_aqin: {
      type: 'Int',
      label: 'Indoor PM sensor humidity',
      suff: '%',
      spokenUnit: 'percent',
      private: true
    },
    aqi_pm25_aqin: {
      type: 'Int',
      label: 'AQI derived from PM25, AQIN sensor',
      private: true
    },
    aqi_pm25_24h_aqin: {
      type: 'Int',
      label: 'AQI derived from PM25 Indoor, 24 hour running average, AQIN sensor',
      private: true
    },
    aqi_pm10_aqin: {
      type: 'Int',
      label: 'AQI derived from PM10 Indoor, AQIN sensor',
      private: true
    },
    aqi_pm10_24h_aqin: {
      type: 'Int',
      label: 'AQI derived from PM10 Indoor, 24 hour running average, AQIN sensor',
      private: true
    },
    aqi_pm25: {
      type: 'Int',
      label: 'AQI derived from PM25'
    },
    aqi_pm25_24h: {
      type: 'Int',
      label: 'AQI derived from PM25, 24 hour running average'
    },
    aqi_pm25_in: {
      type: 'Int',
      private: true,
      label: 'AQI derived from PM25 IN'
    },
    aqi_pm25_in_24h: {
      type: 'Int',
      private: true,
      label: 'AQI derived from PM25 IN, 24 hour running average'
    },
    battout: {
      type: 'Bool',
      private: true,
      label: 'Outdoor Battery'
    },
    battin: {
      type: 'Bool',
      private: true,
      label: 'Indoor Battery'
    },
    batt1: {
      type: 'Bool',
      private: true,
      label: 'Sensor 1 Battery'
    },
    batt2: {
      type: 'Bool',
      private: true,
      label: 'Sensor 2 Battery'
    },
    batt3: {
      type: 'Bool',
      private: true,
      label: 'Sensor 3 Battery'
    },
    batt4: {
      type: 'Bool',
      private: true,
      label: 'Sensor 4 Battery'
    },
    batt5: {
      type: 'Bool',
      private: true,
      label: 'Sensor 5 Battery'
    },
    batt6: {
      type: 'Bool',
      private: true,
      label: 'Sensor 6 Battery'
    },
    batt7: {
      type: 'Bool',
      private: true,
      label: 'Sensor 7 Battery'
    },
    batt8: {
      type: 'Bool',
      private: true,
      label: 'Sensor 8 Battery'
    },
    batt9: {
      type: 'Bool',
      private: true,
      label: 'Sensor 9 Battery'
    },
    batt10: {
      type: 'Bool',
      private: true,
      label: 'Sensor 10 Battery'
    },
    battr1: {
      type: 'Bool',
      private: true,
      label: 'Relay 1 Battery'
    },
    battr2: {
      type: 'Bool',
      private: true,
      label: 'Relay 2 Battery'
    },
    battr3: {
      type: 'Bool',
      private: true,
      label: 'Relay 3 Battery'
    },
    battr4: {
      type: 'Bool',
      private: true,
      label: 'Relay 4 Battery'
    },
    battr5: {
      type: 'Bool',
      private: true,
      label: 'Relay 5 Battery'
    },
    battr6: {
      type: 'Bool',
      private: true,
      label: 'Relay 6 Battery'
    },
    battr7: {
      type: 'Bool',
      private: true,
      label: 'Relay 7 Battery'
    },
    battr8: {
      type: 'Bool',
      private: true,
      label: 'Relay 8 Battery'
    },
    battr9: {
      type: 'Bool',
      private: true,
      label: 'Relay 9 Battery'
    },
    battr10: {
      type: 'Bool',
      private: true,
      label: 'Relay 10 Battery'
    },
    batt_25: {
      type: 'Bool',
      private: true,
      label: 'PM2.5 Battery'
    },
    batt_25in: {
      type: 'Bool',
      private: true,
      label: 'PM2.5 Indoor Battery'
    },
    batleak1: {
      type: 'Bool',
      private: true,
      label: 'Leak Detection 1 Battery'
    },
    batleak2: {
      type: 'Bool',
      private: true,
      label: 'Leak Detection 2 Battery'
    },
    batleak3: {
      type: 'Bool',
      private: true,
      label: 'Leak Detection 3 Battery'
    },
    batleak4: {
      type: 'Bool',
      private: true,
      label: 'Leak Detection 4 Battery'
    },
    batt_lightning: {
      type: 'Bool',
      label: 'Lightning Detector Battery'
    },
    battsm1: {
      type: 'Bool',
      label: 'Soil Moisture 1 Battery'
    },
    battsm2: {
      type: 'Bool',
      label: 'Soil Moisture 2 Battery'
    },
    battsm3: {
      type: 'Bool',
      label: 'Soil Moisture 3 Battery'
    },
    battsm4: {
      type: 'Bool',
      label: 'Soil Moisture 4 Battery'
    },
    batt_co2: {
      type: 'Bool',
      label: 'CO2 battery'
    },
    batt_cellgateway: {
      type: 'Bool',
      label: 'Cellular Gateway battery'
    },
    battvolts: {
      type: 'Float',
      label: 'Battery Voltage',
      suff: 'V'
    },
    batt1volts: {
      type: 'Float',
      label: 'Station Battery',
      suff: 'V',
      avgFormat: toFixed(2)
    },
    batt2volts: {
      type: 'Float',
      label: 'TeleMET Battery',
      suff: 'V',
      avgFormat: toFixed(2)
    },
    leak1: {
      type: 'Int',
      private: true,
      label: 'Leak Detection 1'
    },
    leak2: {
      type: 'Int',
      private: true,
      label: 'Leak Detection 2'
    },
    leak3: {
      type: 'Int',
      private: true,
      label: 'Leak Detection 3'
    },
    leak4: {
      type: 'Int',
      private: true,
      label: 'Leak Detection 4'
    },
    lightning_day: {
      type: 'Int',
      label: 'Lightning strikes per day',
      avgFormat: toFixed(1)
    },
    lightning_hour: {
      type: 'Int',
      label: 'Lightning strikes per hour',
      avgFormat: toFixed(1)
    },
    lightning_distance: {
      type: 'Float',
      label: 'Distance of last lightning strike',
      suff: 'mi',
      units: ['mi', 'km'],
      spokenUnits: ['miles', 'kilometers']
    },
    lightning_time: {
      type: 'Date',
      label: 'Last strike time'
    },
    co2_in: {
      private: true,
      type: 'Int',
      label: 'Indoor CO2 standalone'
    },
    co2_in_24h: {
      private: true,
      type: 'Int',
      label: 'Indoor CO2 standalone, 24 hour running average'
    },
    solarradday: {
      type: 'Float',
      label: 'Solar Radiation Sum',
      suff: ' J/m^2',
      avgFormat: toInt
    },
    leafwet1x: {
      type: 'Bool',
      label: 'Leaf Wetness'
    },
    leafwetsum: {
      type: 'Int',
      label: 'Leaf Wetness Minutes',
      suff: 'min',
      units: ['minutes', 'hours']
    },
    leafwetness1: {
      type: 'Int',
      label: 'Leaf Wetness 1',
      suff: '%'
    },
    leafwetness2: {
      type: 'Int',
      label: 'Leaf Wetness 2',
      suff: '%'
    },
    leafwetness3: {
      type: 'Int',
      label: 'Leaf Wetness 3',
      suff: '%'
    },
    leafwetness4: {
      type: 'Int',
      label: 'Leaf Wetness 4',
      suff: '%'
    },
    leafwetness5: {
      type: 'Int',
      label: 'Leaf Wetness 5',
      suff: '%'
    },
    leafwetness6: {
      type: 'Int',
      label: 'Leaf Wetness 6',
      suff: '%'
    },
    leafwetness7: {
      type: 'Int',
      label: 'Leaf Wetness 7',
      suff: '%'
    },
    leafwetness8: {
      type: 'Int',
      label: 'Leaf Wetness 8',
      suff: '%'
    },
    soiltens1: {
      type: 'Float',
      label: 'Soil Tension 1',
      suff: 'cb',
      units: ['cb', 'kPa']
    },
    soiltens2: {
      type: 'Float',
      label: 'Soil Tension 2',
      suff: 'cb',
      units: 'soiltens1'
    },
    soiltens3: {
      type: 'Float',
      label: 'Soil Tension 3',
      suff: 'cb',
      units: 'soiltens1'
    },
    soiltens4: {
      type: 'Float',
      label: 'Soil Tension 4',
      suff: 'cb',
      units: 'soiltens1'
    },
    gdd: {
      type: 'Int',
      label: 'Growing Degree Days',
      suff: 'days',
      avgFormat: toFixed(1)
    },
    etos: {
      type: 'Float',
      label: 'Evapotranspiration short',
      suff: 'in/day',
      units: ['in/day', 'mm/day']
    },
    etrs: {
      type: 'Float',
      label: 'Evapotranspiration, tall',
      units: 'etos'
    },
    wbgtf: {
      type: 'Float',
      label: 'WBGT',
      suff: '°F',
      units: 'tempf',
      simpleGraph: true
    },
    wbgtflagzone: {
      type: 'String',
      label: 'Zone'
    },
    heatindexf: {
      type: 'Float',
      label: 'Heat Index',
      suff: '°F',
      private: true,
      units: 'tempf',
      simpleGraph: true
    },
    blackglobef: {
      type: 'Float',
      label: 'Black Globe',
      suff: '°F',
      private: true,
      units: 'tempf',
      simpleGraph: true
    },
    wetbulbf: {
      type: 'Float',
      label: 'Wet Bulb',
      suff: '°F',
      private: true,
      units: 'tempf',
      simpleGraph: true
    },
    nawbf: {
      type: 'Float',
      label: 'NAWB',
      suff: '°F',
      private: true,
      units: 'tempf',
      simpleGraph: true
    },
    pig: {
      type: 'Float',
      label: 'PIG',
      suff: '%',
      private: true,
      simpleGraph: true
    },
    dischargeft3s: {
      type: 'Float',
      label: 'Discharge Rate',
      suff: 'ft3/s',
      units: 'ft3s'
    },
    gaugeheightft: {
      type: 'Float',
      label: 'Gauge Height',
      suff: 'ft',
      units: 'ft'
    },
    watermeasph: {
      type: 'Float',
      label: 'Water pH',
      suff: 'pH',
      units: 'pH'
    },
    waternitratesmgl: {
      type: 'Float',
      label: 'Water Nitrates',
      suff: 'mg/l',
      units: 'mgl'
    },
    evapratelbft3hr: {
      type: 'Float',
      label: 'Evaporation Rate',
      suff: 'lb/ft^2/hr',
      private: true,
      simpleWidget: true,
      units: ['lb/ft^2/hr', 'kg/m^2/hr'],
      simpleGraph: true
    },
    twlwm2: {
      type: 'Float',
      label: 'Thermal Work Limit',
      suff: 'W/m^2',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    densityaltitudeft: {
      type: 'Float',
      label: 'Density Altitude',
      suff: 'ft',
      private: true,
      simpleWidget: true,
      simpleGraph: true,
      units: 'altitudeft'
    },
    crosswindmph: {
      type: 'Float',
      label: 'Crosswind/Headwind',
      suff: 'mph',
      private: true,
      simpleGraph: true,
      units: 'windspeedmph'
    },
    headwindmph: {
      type: 'Float',
      label: 'Crosswind/Headwind',
      suff: 'mph',
      private: true,
      simpleGraph: true,
      units: 'windspeedmph'
    },
    ahlu1: {
      type: 'Float',
      label: 'AHLU 1',
      suff: '',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    ahlu2: {
      type: 'Float',
      label: 'AHLU 2',
      suff: '',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    ahlu3: {
      type: 'Float',
      label: 'AHLU 3',
      suff: '',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    humidityratiogplb: {
      type: 'Int',
      label: 'Humidity Ratio',
      suff: 'gr/lb',
      private: true,
      units: ['gr/lb', 'gr/kg'],
      simpleWidget: true,
      simpleGraph: true
    },
    airdensitylbft3: {
      type: 'Float',
      label: 'Air Density',
      suff: 'lb/ft^3',
      private: true,
      simpleGraph: true,
      units: ['lb/ft^3', 'kg/m^3']
    },
    relativeairdensity: {
      type: 'Float',
      label: 'Relative Air Density',
      suff: '%',
      private: true,
      simpleGraph: true
    },
    altitudeft: {
      type: 'Float',
      label: 'Altitude',
      suff: 'ft',
      private: true,
      simpleWidget: true,
      simpleGraph: true,
      units: ['ft', 'm']
    },
    deltaf: {
      type: 'Float',
      label: 'Delta T',
      suff: '°F',
      private: true,
      units: 'tempf',
      simpleGraph: true,
      simpleWidget: true
    },
    airflowcfm: {
      type: 'Float',
      label: 'Volume Air Flow',
      suff: 'cfm',
      private: true,
      simpleWidget: true,
      units: ['cfm', 'm^3/min'],
      simpleGraph: true
    },
    windchillf: {
      type: 'Float',
      label: 'Wind Chill',
      suff: '°F',
      units: 'tempf',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    thinrc: {
      type: 'Float',
      label: 'Temperature Humidity Index (NRC)',
      suff: '',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    thiyousef: {
      type: 'Float',
      label: 'Temperature Humidity Index (Yousef)',
      suff: '',
      private: true,
      simpleWidget: true,
      simpleGraph: true
    },
    leafwetday: {
      type: 'Int',
      label: 'Leaf Wetness, Daily Sum',
      suff: 'min',
      units: 'leafwetsum'
    }
  },
  getPropsByType: function getPropsByType(type) {
    return weatherUtils.keysWithValue(type, funcs.DATA_SPEC);
  }
};
module.exports = {
  dataSpec: dataSpec
};